import { render } from "./GiftItemPurchasePopup.vue?vue&type=template&id=5c1b83cf&scoped=true"
import script from "./GiftItemPurchasePopup.vue?vue&type=script&lang=js"
export * from "./GiftItemPurchasePopup.vue?vue&type=script&lang=js"

import "./GiftItemPurchasePopup.vue?vue&type=style&index=0&id=5c1b83cf&scoped=true&lang=css"

import exportComponent from "/home/viewchat/public_html/viewchat-web-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c1b83cf"]])

export default __exports__